<template>
  <Loading :show="showLoading" />
  <LinkInvalido     v-if="isLinkInvalido" />
  <LinkExpirado     v-else-if="isLinkExpirado" />
  <LinkComTransacao v-else-if="isLinkComTransacao" v-bind:statustrasacao="statustransacao"/>
  <Checkout         v-else v-bind:pedidoResponse="pedidoResponse" />
</template>

<script>

import Checkout     from './Checkout';
import LinkExpirado from './LinkExpirado';
import LinkInvalido from './LinkInvalido';
import LinkComTransacao from './LinkComTransacao';

import Service          from '../services/Api';
import PedidoResponse   from "../model/PedidoResponse";
import Loading        from '../components/Loading/index.vue'; 


export default {

  components: {Checkout, LinkExpirado,  LinkInvalido, LinkComTransacao, Loading},

  data: () => ({
    isLinkExpirado: false,
    isLinkInvalido: false,
    isLinkComTransacao: false,
    pedidoResponse: PedidoResponse,
    showLoading: true,

    statustransacao: {}
  }),

  created(){
    this.pedidoResponse = new PedidoResponse("0" , 0 , 0, 0)

    if(this.$route.params.uuid){
      this.showLoading = true;
      console.log("2" + this.showLoading)
      this.validaUuid(this.$route.params.uuid);
      return;
    }
    console.log("3" + this.showLoading)
    this.showLoading = false;
    this.isLinkExpirado     = false;
    this.isLinkComTransacao = false;
    this.isLinkInvalido     = true;
  },

  methods: {

    validaUuid: function(uuid) {

      Service.validaLink(uuid).then(response => {
        
         if (response.status === 200 && response.data.status === '205') {
          this.isLinkExpirado  = false;
          this.isLinkInvalido  = false;
          this.isLinkComTransacao = true;
          this.statustransacao = response.data;
          this.showLoading = false;
          return;
        }


        if(response.status === 200){
          this.isLinkExpirado = false;
          this.isLinkInvalido = false;
          this.isLinkComTransacao = false;
          this.pedidoResponse = new PedidoResponse("" , response.data.value , 1, "", response.data.name, response.data.description)
          //PagSeguroDirectPayment.setSessionId(this.pedidoResponse.id);
          this.showLoading = false;
          return;
        }

        if(response.status === 204){
          this.isLinkExpirado  = true;
          this.isLinkInvalido  = false;
          this.isLinkComTransacao = false;
          this.showLoading = false;
          return;
        }
        
        this.showLoading = false;
        
      }).catch( error => {
        console.log(error);
        this.isLinkInvalido = true;
        this.isLinkExpirado = false;
        this.showLoading = false;
        
      });

    }

  }

}


</script>
